import { Component, Input } from '@angular/core'
import { SKELETON_LOADER_CONSTANTS } from '../../../../core/constants/skeleton-loader.constants'

@Component({
    selector: 'app-table-skeleton-loader',
    templateUrl: './table-skeleton-loader.component.html',
    styleUrls: ['./table-skeleton-loader.component.scss'],
})
export class TableSkeletonLoaderComponent {
    @Input() loading = false
    @Input() rows: number = SKELETON_LOADER_CONSTANTS.TABLE.ROWS
    @Input() columns: number = SKELETON_LOADER_CONSTANTS.TABLE.COLUMNS
    @Input() showHeader = SKELETON_LOADER_CONSTANTS.TABLE.SHOW_HEADER
    @Input() columnWidths: string[] = [...SKELETON_LOADER_CONSTANTS.TABLE.COLUMN_WIDTHS]
    @Input() headerHeight: string = SKELETON_LOADER_CONSTANTS.TABLE.HEADER_HEIGHT
    @Input() rowHeight: string = SKELETON_LOADER_CONSTANTS.TABLE.ROW_HEIGHT

    get rowsArray(): number[] {
        return Array.from({ length: this.rows }, (_, i) => i)
    }

    get columnsArray(): number[] {
        return Array.from({ length: this.columns }, (_, i) => i)
    }

    get columnWidthsArray(): string[] {
        if (this.columnWidths.length === this.columns) {
            return this.columnWidths
        }
        // Default column widths matching the actual table structure
        const defaultWidths = [...SKELETON_LOADER_CONSTANTS.TABLE.COLUMN_WIDTHS]
        return defaultWidths.slice(0, this.columns)
    }
}
